import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ControllerComponent} from '../../../../Controller/controller-component';
import {DeliveryNoteDto} from '../../../../../Models/Purchases/Delivery-notes/delivery-note.interface';
import {OrderDto} from '../../../../../Models/Purchases/Orders/order.interface';
import {LinesDto} from '../../../../../Models/Purchases/Shared/line.interface';

@Component({
  selector: 'app-lines-item',
  templateUrl: './lines-item.component.html',
  styleUrls: ['./lines-item.component.scss'],
  standalone: false
})
export class LinesItemComponent extends ControllerComponent {
  @Input() data!: DeliveryNoteDto | OrderDto;
  @Input() item!: LinesDto;

  @Input() quantity: number = 0;

  @Input() showCheckbox: boolean = false;
  @Input() ngModelCheckbox: string = 'confirmar';

  @Output() editProduct: EventEmitter<void> = new EventEmitter<void>();
}
